import { Title } from '../styles'

import { config } from './config'
import { ClientImage, HexagonOrange, SubTitle, Wrapper } from './styles'

const {
  client: { title, subtitle },
  clientImage,
  hexagonOrange,
} = config

export function Client() {
  return (
    <Wrapper>
      <HexagonOrange {...hexagonOrange} />
      <Title as="h2">{title}</Title>
      <SubTitle>{subtitle}</SubTitle>
      {clientImage && <ClientImage {...clientImage} />}
    </Wrapper>
  )
}
